import React from "react";

import LocalizedLink from "../../containers/LocalizedLink";

const CompositionCreate = () => (
  <div className="composition composition__img--add">
    <div className="composition__zone">
      <div className="composition__icon">
        <LocalizedLink className="button composition__icon-button button--icon" to="/create">
          <i className="button__icon i-icon-plus" />
        </LocalizedLink>
      </div>
    </div>
  </div>
);

export default CompositionCreate;



// WEBPACK FOOTER //
// ./src/components/account/CompositionCreate.js